export default __webpack_public_path__ + "static/media/slide--8.4f654be7.jpg";